import React, { Fragment } from "react";
import { Button, Table } from "react-bootstrap";

// --------------------------------------------------------------------
//
//  ProfessorHomeForm
//
// --------------------------------------------------------------------
export const ProfessorHomeForm = ({ professors, handleDetail }) => {
  const column_max = 5;

  let rowHeader = [];

  for (let i = 0; i < column_max; i++) {
    rowHeader.push(
      <Fragment key={i}>
        <th>이름</th>
        <th>교번</th>
        <th style={{ visibility: "hidden" }}> </th>
      </Fragment>
    );
  }

  let rowProfessors = [];
  if (professors) {
    let temp = [];
    for (let i = 0; i < professors.length; i += column_max) {
      temp.push(professors.slice(i, i + column_max));
    }

    rowProfessors = temp.map((it, index) => {
      return (
        <tr key={index}>
          {it.map((st, sIndex) => {
            return (
              <Fragment key={sIndex}>
                <td>{st.displayName}</td>
                <td>{st.username}</td>
                <td>
                  <Button size="sm" onClick={handleDetail} value={st._id}>
                    상세
                  </Button>
                </td>
              </Fragment>
            );
          })}
        </tr>
      );
    });
  } else {
    return <Fragment></Fragment>;
  }

  return (
    <Fragment>
      <Table striped>
        <thead>
          <tr>{rowHeader}</tr>
        </thead>
        <tbody>
          {rowProfessors ?? (
            <tr>
              <td>데이타가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Fragment>
  );
};
